var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQrIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 5.33333H13.3333V13.3333H5.33333V5.33333ZM26.6667 5.33333V13.3333H18.6667V5.33333H26.6667ZM18.6667 20H21.3333V17.3333H18.6667V14.6667H21.3333V17.3333H24V14.6667H26.6667V17.3333H24V20H26.6667V24H24V26.6667H21.3333V24H17.3333V26.6667H14.6667V21.3333H18.6667V20ZM21.3333 20V24H24V20H21.3333ZM5.33333 26.6667V18.6667H13.3333V26.6667H5.33333ZM8 8V10.6667H10.6667V8H8ZM21.3333 8V10.6667H24V8H21.3333ZM8 21.3333V24H10.6667V21.3333H8ZM5.33333 14.6667H8V17.3333H5.33333V14.6667ZM12 14.6667H17.3333V20H14.6667V17.3333H12V14.6667ZM14.6667 8H17.3333V13.3333H14.6667V8ZM2.66667 2.66667V8H0V2.66667C0 1.95942 0.280952 1.28115 0.781049 0.781049C1.28115 0.280952 1.95942 0 2.66667 0L8 0V2.66667H2.66667ZM29.3333 0C30.0406 0 30.7189 0.280952 31.219 0.781049C31.719 1.28115 32 1.95942 32 2.66667V8H29.3333V2.66667H24V0H29.3333ZM2.66667 24V29.3333H8V32H2.66667C1.95942 32 1.28115 31.719 0.781049 31.219C0.280952 30.7189 0 30.0406 0 29.3333V24H2.66667ZM29.3333 29.3333V24H32V29.3333C32 30.0406 31.719 30.7189 31.219 31.219C30.7189 31.719 30.0406 32 29.3333 32H24V29.3333H29.3333Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/QrIcon.d4ce5fab.svg";
export { ForwardRef as ReactComponent };